import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

export default function OFEVendorDirectory() {
  const { user } = useAuth();
  const [search, setSearch] = useState('');
  const { data: vendors, loading, error } = useOFEFetch('/ofe/vendors?active_only=true', user);

  const filtered = (vendors || []).filter(v =>
    v.vendor_name.toLowerCase().includes(search.toLowerCase()) ||
    v.vendor_code.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-white">Vendor Directory</h1>
        <input
          value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Search vendors..."
          className="bg-gray-800 border border-gray-600 text-white px-3 py-1.5 rounded text-sm w-64"
        />
      </div>

      {loading && <div className="text-gray-400">Loading vendors...</div>}
      {error && <div className="text-red-400">Error: {error}</div>}

      <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-900 text-gray-400">
            <tr>
              <th className="text-left px-4 py-3">Code</th>
              <th className="text-left px-4 py-3">Vendor Name</th>
              <th className="text-left px-4 py-3">Type</th>
              <th className="text-left px-4 py-3">Equipment Types</th>
              <th className="text-left px-4 py-3">MSA</th>
              <th className="text-left px-4 py-3">Rating</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {filtered.map(v => (
              <tr key={v.id} className="hover:bg-gray-750 transition-colors">
                <td className="px-4 py-3 font-mono text-blue-400">{v.vendor_code}</td>
                <td className="px-4 py-3 text-white font-semibold">{v.vendor_name}</td>
                <td className="px-4 py-3 text-gray-300">{v.vendor_type || '—'}</td>
                <td className="px-4 py-3 text-gray-300 text-xs">
                  {(v.equipment_types || []).join(', ') || '—'}
                </td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${
                    v.msa_status === 'active' ? 'bg-green-900/40 text-green-400' : 'bg-gray-700 text-gray-400'
                  }`}>{v.msa_status || 'none'}</span>
                </td>
                <td className="px-4 py-3 text-gray-300">{v.quality_rating ?? '—'}</td>
                <td className="px-4 py-3">
                  <Link to={`/ofe/vendors/${v.id}`} className="text-blue-400 hover:text-blue-300 text-xs">Detail →</Link>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && !loading && (
              <tr><td colSpan={7} className="px-4 py-8 text-center text-gray-500">No vendors found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
